import React from 'react';
import Helmet from 'react-helmet';
import SheetTitle from '../../components/SheetTitle/SheetTitle';
import { smoothScroll } from '../../helpers/view';

import c from './PrivatePolicy.less';

export default class PrivacyPolicy extends React.PureComponent {
  componentDidMount() {
    smoothScroll();
  }

  render() {
    return (
      <div className={c.container}>
        <Helmet defer={false}>
          <title>Privacy Policy at Mp3Caprice</title>
          <meta property="mc:dp" content="/shop/privacy-policy" />
          <meta property="mc:page" content="Privacy Policy" />
        </Helmet>
        <SheetTitle title="Privacy Policy" />
        <h3>The information that we may collect</h3>

        <p>What information we collect:</p>
        <ul>
          <li>
            <strong>Email address</strong>
            <br />
            We need your email address to provide the best and convenient service for you.
            <br />
            Each email address registered with Mp3Caprice serves as an identification for the respective account. We use
            your email address to inform about the important activity on your account, news related to Mp3Caprice
            service
            and bonus offers. We do not send out any spam mail.

          </li>
          <li>
            <strong>First and last name, date of birth</strong>
            <br />
            Providing these data is optional for the user. If provided, the first name and last name is used to address
            the user in a friendly and correct manner, in case of support contact.
            <br />

            The date of birth is used for statistical purposes and for the birthday special offers.
          </li>
          <li>
            <strong>Web browser, device, and OS specs</strong>
            <br />
            We use your web browser, device, and OS specs in order to improve the service usability for our users.
            Considering the web browser, device and OS specs the interface and functionality of the service works
            specifically for your needs.
          </li>
          <li>
            <strong>IP Address and the location country</strong>
            <br />
            We need to know your IP address and location country as our service functions in a limited number of
            countries.
          </li>
        </ul>

        <p><strong>We do not share or sell any information our users trust us with.</strong></p>

        <p>
          Your personal information is saved in our registry no longer than needed. In case you decide to stop using
          Mp3Caprice services, you can delete your account and request your data removed from our registry.
        </p>
        <h3>How do we protect your information?</h3>
        <p>
          All communications with the site are secured using an SSL Certificate. This ensures that all information you
          send to us via the World Wide Web will be encrypted. If any other Internet user intercepts the communication
          he/she will only be able to see it in an encrypted (garbled) form.
        </p>

        <h3>Do we use cookies?</h3>

        <p>
          Yes. To give you the best possible experience, the site uses cookies. Using Mp3Caprice.com you agree to us
          using cookies.
        </p>

        <ul>
          <li>
            <em>What are &quot;cookies&quot;?</em>
            <br />
            &quot;Cookies&quot; are small text files that are stored by the browser (for example, Google Chrome or
            Firefox) on your computer or mobile phone. They allow websites to store things like user preferences. You
            can
            think of cookies as providing a &quot;memory&quot; for the website so that it can recognize you when you
            come
            back and
            respond appropriately.
          </li>
          <li>
            <em>Authorization cookies</em>
            <br />
            Mp3Caprice uses only one kind of cookies. When you log in with Mp3Caprice, we generate cookies that let us
            know whether you are logged in or not. Our servers use these cookies to work out which account you are
            logged
            in with, and if you are allowed access to a particular service.
          </li>

          <li>
            <em>How do I turn cookies off?</em>
            <br />
            It is usually possible to stop your browser accepting cookies, or to stop it accepting cookies from a
            particular website. However, we cannot tell if you are logged in without using cookies, so you would not be
            able to purchase and download music. All modern browsers allow you to change your cookie settings. You can
            usually find these settings in the &quot;options&quot; or &quot;preferences&quot; menu of your browser.
          </li>
        </ul>

        <h3>Our disclosure of your information</h3>
        <p>
          We do not sell, trade, lend or rent any personally identifiable information about you to any third party
          outside
          Mp3Caprice.
          We may release your information when we believe release is appropriate to comply with the law, enforce our
          site
          policies, or protect ours or others rights, property, or safety.
        </p>

        <h3>Third party links</h3>

        <p>
          We may include or offer third party products or services on our website. These third party sites have separate
          and independent privacy policies. We, therefore, have no responsibility or liability for the content and
          activities of these linked sites. However, we seek to protect the integrity of our site and welcome any
          feedback
          about these sites.
        </p>

        <h3>Changes to our Privacy Policy</h3>
        <p>
          Mp3Caprice reserves the right to change this privacy policy at any time by posting revisions on this Web page.
          Such changes will be effective upon posting.
          We inform our users about any possible changes in a timely manner via email. Last Updated: May 5, 2018
        </p>
      </div>
    );
  }
}
